import { tw } from "@careinfo/tailwind";
import { useState, type HTMLAttributes } from "react";
import {
  useController,
  type Control,
  type FieldPath,
  type FieldValues,
} from "react-hook-form";

interface Props<T extends FieldValues>
  extends HTMLAttributes<HTMLInputElement> {
  control: Control<T>;
  name: FieldPath<T>;
  icon?: React.ReactElement;
  placeholder?: string;
  label?: string;
  disabled?: boolean;
}

const TextField = <T extends FieldValues>({
  control,
  name,
  placeholder,
  icon,
  label,
  disabled,
  ...elementAttributes
}: Props<T>) => {
  const [isFocus, setIsFocus] = useState(false);
  const {
    field: { value = "", onChange, ref },
    fieldState: { error },
  } = useController<T>({
    name,
    control,
    defaultValue: null,
  });

  return (
    <>
      <div className={tw`w-full  text-left`}>
        <label
          htmlFor={name}
          className={tw`w-full flex flex-col cursor-pointer`}
        >
          {label}
          <input
            {...elementAttributes}
            placeholder={placeholder}
            defaultValue={value}
            disabled={disabled}
            id={name}
            onFocus={() => setIsFocus(true)}
            className={tw`w-full focus:outline-none bg-[#EEF5F4] p-2 mt-1`}
            onChange={(e) => {
              onChange(e.target.value);
              setIsFocus(true);
            }}
            ref={ref}
          />
        </label>
        {error && (
          <p className={tw`text-red-500 text-xs my-1`}>
            {JSON.stringify(error?.message)}
          </p>
        )}
      </div>
    </>
  );
};

export default TextField;
